import { render, staticRenderFns } from "./AccountManagementUserBehaviorTab.container.vue?vue&type=template&id=afa44742&scoped=true&"
import script from "./AccountManagementUserBehaviorTab.container.vue?vue&type=script&lang=ts&"
export * from "./AccountManagementUserBehaviorTab.container.vue?vue&type=script&lang=ts&"
import style0 from "./AccountManagementUserBehaviorTab.container.vue?vue&type=style&index=0&id=afa44742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa44742",
  null
  
)

export default component.exports